import EN from './en';
import FR from './fr';
import NL from './nl';
import PT from './pt';
import DE from './de';
import ES from './es';
import IT from './it';

export type Languages = 'fr' | 'nl' | 'en' | 'pt' | 'es' | 'de' | 'it';

type KnowFlags = {
  [key in Languages]: {
    translation: string;
    element: () => JSX.Element;
  };
};

const knowFlags: KnowFlags = {
  de: {
    element: DE,
    translation: 'Deutsch',
  },
  en: {
    element: EN,
    translation: 'English',
  },
  es: {
    element: ES,
    translation: 'Español',
  },
  fr: {
    element: FR,
    translation: 'Français',
  },
  nl: {
    element: NL,
    translation: 'Nederlands',
  },
  pt: {
    element: PT,
    translation: 'Português',
  },
  it: {
    element: IT,
    translation: 'Italian',
  },
};

const Flags = ({ lang }: { lang: Languages }) => {
  if (!knowFlags[lang]) return null;

  return knowFlags[lang].element();
};

export default Flags;
